import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-response-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-modal.component.html',
  styleUrl: './response-modal.component.scss'
})
export class ResponseModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; type: string; message: string },
    private dialogRef: MatDialogRef<ResponseModalComponent>
  ) {}

  closeModal() {
    this.dialogRef.close();
  }
}
